"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SEO;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("@whitbread-eos/api");
var _utils = require("@whitbread-eos/utils");
var _head = _interopRequireDefault(require("next/head"));
var _router = require("next/router");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SEO(_ref) {
  var _tripAdvisorReviews$r, _breadcrumbs$map, _breadcrumbsList, _breadcrumbsList2, _faq$faqItems, _tripAdvisorReviews$r2;
  var {
    data,
    isLoading,
    isError,
    displayMeta,
    breadcrumbs,
    tripAdvisorReviews,
    hotelsList,
    showBreadcrumbs = false
  } = _ref;
  var {
    [_api.FT_PI_HREFLANG_ATTRIBUTE]: isHreflangAttributeEnabled
  } = (0, _utils.useFeatureToggle)();
  var {
    country,
    language
  } = (0, _utils.useCustomLocale)();
  var isSEOBreadcrumbEnabled = (0, _utils.useFeatureSwitch)({
    featureSwitchKey: _api.FS_ENABLE_SEO_BREADCRUMB_PI,
    fallbackValue: false
  });
  var router = (0, _router.useRouter)();
  var {
    pageTitle,
    pageDescription,
    cardImageUrl,
    faviconUrl,
    icons,
    msIcons,
    faq,
    hreflangs
  } = data;
  var hdpReviewsRating = tripAdvisorReviews === null || tripAdvisorReviews === void 0 || (_tripAdvisorReviews$r = tripAdvisorReviews.reviews) === null || _tripAdvisorReviews$r === void 0 ? void 0 : _tripAdvisorReviews$r.map(review => review.rating);
  if (isLoading || isError) {
    return null;
  }
  var breadcrumbsList = (_breadcrumbs$map = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map((breadcrumbItem, index) => _objectSpread(_objectSpread({}, breadcrumbItem), {}, {
    position: index + 1
  }))) !== null && _breadcrumbs$map !== void 0 ? _breadcrumbs$map : [];
  var hasBreadcrumbs = breadcrumbsList && ((_breadcrumbsList = breadcrumbsList) === null || _breadcrumbsList === void 0 ? void 0 : _breadcrumbsList.length) > 0;
  if (hasBreadcrumbs && !((_breadcrumbsList2 = breadcrumbsList[breadcrumbsList.length - 1]) !== null && _breadcrumbsList2 !== void 0 && _breadcrumbsList2.link)) {
    breadcrumbsList = breadcrumbsList.slice(0, -1);
  }
  return (0, _jsxRuntime.jsxs)(_head.default, {
    children: [(0, _jsxRuntime.jsx)("title", {
      children: pageTitle
    }), (0, _jsxRuntime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1, user-scalable=no"
    }), displayMeta && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)("meta", {
        name: "description",
        content: pageDescription
      }), (0, _jsxRuntime.jsx)("meta", {
        name: "robots",
        content: "index,follow"
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "twitter:card",
        content: "summary"
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "twitter:url",
        content: getCurrentPageURL()
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "twitter:title",
        content: pageTitle
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "twitter:description",
        content: pageDescription
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "twitter:image",
        content: cardImageUrl
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "twitter:site",
        content: "Premier Inn"
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "twitter:creator"
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "og:url",
        content: getCurrentPageURL()
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "og:title",
        content: pageTitle
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "og:description",
        content: pageDescription
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "og:image",
        content: cardImageUrl
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "og:site_name",
        content: "Premier Inn"
      }), (0, _jsxRuntime.jsx)("meta", {
        property: "fb:admins"
      }), (0, _jsxRuntime.jsx)("meta", {
        name: "msapplication-TileColor",
        content: "#552462"
      }), renderItems(msIcons, icon => (0, _jsxRuntime.jsx)("meta", {
        name: icon.name,
        content: icon.content
      }, icon.name)), isHreflangAttributeEnabled && renderItems(hreflangs, _ref2 => {
        var {
          hreflang,
          href
        } = _ref2;
        return (0, _jsxRuntime.jsx)("link", {
          rel: "alternate",
          hrefLang: hreflang,
          href: href
        }, hreflang);
      }), renderItems(icons, icon => (0, _jsxRuntime.jsx)("link", {
        rel: icon.rel,
        sizes: icon.sizes,
        href: (0, _utils.formatAssetsUrl)(icon.href)
      }, icon.href))]
    }), (0, _jsxRuntime.jsx)("link", {
      rel: "icon",
      type: "image/x-icon",
      href: (0, _utils.formatAssetsUrl)(faviconUrl)
    }), (0, _jsxRuntime.jsx)("link", {
      rel: "canonical",
      href: getCanonicalURL(router.locale, hreflangs)
    }), hasBreadcrumbs && (isSEOBreadcrumbEnabled || showBreadcrumbs) && (0, _jsxRuntime.jsx)("script", {
      "data-testid": "seobreadcrumbs",
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: "{\"@context\":\"http://schema.org\",\"@type\":\"BreadcrumbList\",\"itemListElement\":[".concat(breadcrumbFormatter(breadcrumbsList), "]}")
      }
    }), faq && (faq === null || faq === void 0 || (_faq$faqItems = faq.faqItems) === null || _faq$faqItems === void 0 ? void 0 : _faq$faqItems.length) > 0 && (0, _jsxRuntime.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: "{\"@context\":\"http://schema.org\",\"@type\":\"FAQPage\",\"mainEntity\":[".concat(faqFormatter(faq.faqItems), "]}")
      }
    }), (tripAdvisorReviews === null || tripAdvisorReviews === void 0 ? void 0 : tripAdvisorReviews.reviews) && (tripAdvisorReviews === null || tripAdvisorReviews === void 0 || (_tripAdvisorReviews$r2 = tripAdvisorReviews.reviews) === null || _tripAdvisorReviews$r2 === void 0 ? void 0 : _tripAdvisorReviews$r2.length) > 0 && (0, _jsxRuntime.jsx)("script", {
      "data-testid": "seoRating",
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: "{\"@context\":\"http://schema.org\",\"@type\": \"Review\",\"name\": \"".concat(tripAdvisorReviews.name, "\", \"itemReviewed\": {\"@type\": \"Hotel\", \"name\": \"").concat(tripAdvisorReviews.name, "\" \n          }, \"reviewRating\": {\"@type\": \"Rating\", \"ratingValue\": \"").concat(tripAdvisorReviews.rating, "\" },\n          \"review\": [").concat(ratingFormatter(tripAdvisorReviews.reviews), "],\"aggregateRating\": {\n          \"@type\": \"AggregateRating\",\"ratingValue\": \"").concat(tripAdvisorReviews.rating, "\",\"bestRating\": \"").concat(hdpReviewsRating && Math.max(...hdpReviewsRating), "\",\n          \"ratingCount\": \"").concat(tripAdvisorReviews.numberOfReviews, "\"\n          }}")
      }
    }), hotelsList && (hotelsList === null || hotelsList === void 0 ? void 0 : hotelsList.length) > 0 && (0, _jsxRuntime.jsx)("script", {
      "data-testid": "seoHotelsList",
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: "{\"@context\":\"http://schema.org\",\"@type\": \"ItemList\",\"itemListElement\": [".concat(hotelsListFormatter(hotelsList), "]}")
      }
    })]
  });
  function faqFormatter(faqItems) {
    var _faqItems$map;
    return (_faqItems$map = faqItems.map(faqItem => {
      var _faqItem$answer;
      return "{\"@type\":\"Question\",\"name\":\"".concat(faqItem.question, "\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"").concat((_faqItem$answer = faqItem.answer) === null || _faqItem$answer === void 0 ? void 0 : _faqItem$answer.replace(/(\r\n|\n|\r)/gm, '').replace(/"/g, '\\"'), "\"}}");
    })) === null || _faqItems$map === void 0 ? void 0 : _faqItems$map.join(',');
  }
  function breadcrumbFormatter(breadcrumbs) {
    var _breadcrumbs$map2;
    return (_breadcrumbs$map2 = breadcrumbs.map(breadcrumbItem => {
      return "{\"@type\":\"ListItem\",\n        \"position\":\"".concat(breadcrumbItem.position, "\",\n        \"name\":\"").concat(breadcrumbItem.title, "\",\"item\":\"").concat((0, _utils.formatAssetsUrl)(breadcrumbItem.link), "\"}");
    })) === null || _breadcrumbs$map2 === void 0 ? void 0 : _breadcrumbs$map2.join(',');
  }
  function ratingFormatter(ratings) {
    var _ratings$map;
    return (_ratings$map = ratings.map(ratingItem => {
      var _ratingItem$user;
      return "{\n        \"@type\": \"Review\",\n        \"reviewRating\": {\n          \"@type\": \"Rating\",\n          \"ratingValue\": \"".concat(ratingItem.rating, "\"\n        },\n        \"reviewBody\": \"").concat(ratingItem.text, "\",\n        \"author\": {\n          \"@type\": \"Person\",\n          \"name\": \"").concat(ratingItem === null || ratingItem === void 0 || (_ratingItem$user = ratingItem.user) === null || _ratingItem$user === void 0 ? void 0 : _ratingItem$user.username, "\"\n        }\n       }");
    })) === null || _ratings$map === void 0 ? void 0 : _ratings$map.join(',');
  }
  function hotelsListFormatter(hotelsList) {
    var _hotelsList$map;
    return (_hotelsList$map = hotelsList.map((hotel, i) => {
      var _hotel$tripAdvisorRev, _hotel$tripAdvisorRev2, _hotel$tripAdvisorRev3, _hotel$coordinates, _hotel$coordinates2, _hotel$coordinates3, _hotel$coordinates4, _hotel$topSectionImag, _hotel$topSectionImag2, _hotel$hotelDescripti, _hotel$links, _hotel$address$cityNa, _hotel$address, _hotel$address2, _hotel$address3, _hotel$address4, _hotel$address5, _hotel$address6, _hotel$address7, _hotel$address8, _hotel$address9, _hotel$address10;
      var reviewsRating = hotel === null || hotel === void 0 || (_hotel$tripAdvisorRev = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev === void 0 || (_hotel$tripAdvisorRev = _hotel$tripAdvisorRev.reviews) === null || _hotel$tripAdvisorRev === void 0 ? void 0 : _hotel$tripAdvisorRev.map(review => review.rating);
      var tripAdvisorSection = ",\"aggregateRating\": {\"@type\": \"AggregateRating\",\"ratingValue\": \"".concat((_hotel$tripAdvisorRev2 = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev2 === void 0 ? void 0 : _hotel$tripAdvisorRev2.rating, "\",\"bestRating\": \"").concat(reviewsRating && Math.max(...reviewsRating), "\", \"ratingCount\": \"").concat((_hotel$tripAdvisorRev3 = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev3 === void 0 ? void 0 : _hotel$tripAdvisorRev3.numberOfReviews, "\"}");
      return "{\"@type\": \"ListItem\",\"position\": ".concat(i + 1, ",\"item\": {\"@type\": \"Hotel\",\"hasMap\":\n        \"https://maps.googleapis.com/maps/api/staticmap?sensor=false&zoom=15&size=1600x1200&center=").concat((_hotel$coordinates = hotel.coordinates) === null || _hotel$coordinates === void 0 ? void 0 : _hotel$coordinates.latitude, ",\n        ").concat((_hotel$coordinates2 = hotel.coordinates) === null || _hotel$coordinates2 === void 0 ? void 0 : _hotel$coordinates2.longitude, "&markers=color:0x511E62%7c").concat((_hotel$coordinates3 = hotel.coordinates) === null || _hotel$coordinates3 === void 0 ? void 0 : _hotel$coordinates3.latitude, ",\n        ").concat((_hotel$coordinates4 = hotel.coordinates) === null || _hotel$coordinates4 === void 0 ? void 0 : _hotel$coordinates4.longitude, "&key=").concat(process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY, "\",\n        \"priceRange\": \"$$\",\"name\": \"").concat(hotel.name, "\",\n        \"image\": \"").concat((0, _utils.formatAssetsUrl)((_hotel$topSectionImag = (_hotel$topSectionImag2 = hotel.topSectionImages) === null || _hotel$topSectionImag2 === void 0 || (_hotel$topSectionImag2 = _hotel$topSectionImag2[0]) === null || _hotel$topSectionImag2 === void 0 ? void 0 : _hotel$topSectionImag2.thumbnailSrc) !== null && _hotel$topSectionImag !== void 0 ? _hotel$topSectionImag : ''), "\",\n        \"description\": \"").concat((_hotel$hotelDescripti = hotel.hotelDescription) === null || _hotel$hotelDescripti === void 0 ? void 0 : _hotel$hotelDescripti.replace(/(\r\n|\n|\r)/gm, '').replace(/\\/g, '\\\\').replace(/"/g, '\\"'), "\",\"url\": \"https://www.premierinn.com/").concat(country, "/").concat(language, "/hotels").concat((_hotel$links = hotel.links) === null || _hotel$links === void 0 ? void 0 : _hotel$links.detailsPage, ".html\",\"address\": {\"@type\": \"PostalAddress\",\"addressLocality\": \"").concat((_hotel$address$cityNa = (_hotel$address = hotel.address) === null || _hotel$address === void 0 ? void 0 : _hotel$address.cityName) !== null && _hotel$address$cityNa !== void 0 ? _hotel$address$cityNa : (_hotel$address2 = hotel.address) === null || _hotel$address2 === void 0 ? void 0 : _hotel$address2.addressLine2, "\",\"postalCode\": \"").concat((_hotel$address3 = hotel.address) === null || _hotel$address3 === void 0 ? void 0 : _hotel$address3.postalCode, "\",\"streetAddress\": \"").concat((_hotel$address4 = hotel.address) === null || _hotel$address4 === void 0 ? void 0 : _hotel$address4.addressLine1, ", ").concat((_hotel$address5 = hotel.address) === null || _hotel$address5 === void 0 ? void 0 : _hotel$address5.addressLine3, ", ").concat((_hotel$address6 = hotel.address) === null || _hotel$address6 === void 0 ? void 0 : _hotel$address6.postalCode, " ").concat((_hotel$address7 = hotel.address) === null || _hotel$address7 === void 0 ? void 0 : _hotel$address7.addressLine2, ", ").concat((_hotel$address8 = hotel.address) === null || _hotel$address8 === void 0 ? void 0 : _hotel$address8.country, "\",\"addressRegion\": \"").concat((_hotel$address9 = hotel.address) === null || _hotel$address9 === void 0 ? void 0 : _hotel$address9.addressLine3, "\",\"addressCountry\": \"").concat((_hotel$address10 = hotel.address) === null || _hotel$address10 === void 0 ? void 0 : _hotel$address10.country, "\"}").concat(hotel !== null && hotel !== void 0 && hotel.tripAdvisorReviews ? tripAdvisorSection : '', "}}");
    })) === null || _hotelsList$map === void 0 ? void 0 : _hotelsList$map.join(',');
  }
  function getCurrentPageURL() {
    var _window$location;
    return typeof window !== 'undefined' ? (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href : '';
  }
  function renderItems(items, callbackFn) {
    return items && (items === null || items === void 0 ? void 0 : items.length) > 0 && items.map(callbackFn);
  }
  function getCanonicalURL(country, hreflangs) {
    var _hreflangs$find;
    var language = country === 'gb' ? 'en' : 'de';
    return hreflangs === null || hreflangs === void 0 || (_hreflangs$find = hreflangs.find(hreflang => hreflang.hreflang.includes("".concat(language, "-").concat(country)))) === null || _hreflangs$find === void 0 ? void 0 : _hreflangs$find.href;
  }
}